import { Desktop } from 'styles/MediaQueries';
import { DIVIDER_GRAY } from 'styles/Colors';
import Divider from '@mui/material/Divider';
import OpploansLogoSVG from 'images/OppLoansLogo.svg';
import PartnerLogo from 'registration/lead/PartnerLogo';
import React from 'react';

const containerStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '2.25rem',
  maxWidth: '22rem',

  [Desktop]: {
    height: '4.875rem',
    maxWidth: '45rem'
  }
};

const boxStyle = {
  display: 'flex',
  flex: 1
};

const leftStyle = {
  ...boxStyle,
  justifyContent: 'right'
};

const rightStyle = {
  ...boxStyle,
  justifyContent: 'left'
};

const centerStyle = {
  display: 'flex',
  flex: 0
};

const dividerStyle = {
  borderColor: DIVIDER_GRAY,
  height: '2.375rem',
  margin: '1rem 0.5rem',

  [Desktop]: {
    height: '3.75rem',
    margin: '1rem 1.5rem'
  }
};

const opploansLogoWithCobrandingStyle = {
  height: '2.5rem',
  marginTop: '0.1875rem',

  [Desktop]: {
    height: '3.625rem',
    marginTop: '0.375rem'
  }
};

const opploansLogoSoloStyle = {
  height: '3.25rem',
  marginTop: '0.25rem',

  [Desktop]: {
    height: '3.625rem',
    marginTop: '0.375rem'
  }
};

function OpploansLogo({ additionalStyle = {}, withCobranding = false }) {
  const style = withCobranding
    ? opploansLogoWithCobrandingStyle
    : opploansLogoSoloStyle;

  return (
    <OpploansLogoSVG
      data-testid='opploans-logo'
      css={[style, additionalStyle]}
      title='Opploans Logo'
    />
  );
}

function LeadIntroLogos({ partnerId, partnerName, showCobranding }) {
  if (!showCobranding) {
    return <OpploansLogo />;
  }

  return (
    <div css={containerStyle}>
      {showCobranding && (
        <>
          <div css={leftStyle}>
            <PartnerLogo partnerId={partnerId} partnerName={partnerName} />
          </div>

          <div css={centerStyle}>
            <Divider css={dividerStyle} orientation='vertical' flexItem />
          </div>

          <div css={rightStyle}>
            {/* There is some extra whitespace on the left side of the OppLoansLogo
                svg that we need to get rid of with negative margins =( */}
            <OpploansLogo
              additionalStyle={{ marginLeft: '-0.25rem' }}
              withCobranding
            />
          </div>
        </>
      )}
      {!showCobranding && <OpploansLogo />}
    </div>
  );
}

export default LeadIntroLogos;
